var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AuthenticationProvider, Injectable } from "@banta/common";
import { FirebaseStoreRef } from "./firebase-store-ref";
import { JWT } from "@astronautlabs/jwt";
let FirebaseAuthenticationProvider = class FirebaseAuthenticationProvider extends AuthenticationProvider {
    constructor(storeRef) {
        super();
        this.storeRef = storeRef;
    }
    get datastore() {
        return this.storeRef.store;
    }
    validateToken(tokenStr) {
        return __awaiter(this, void 0, void 0, function* () {
            let publicKeyUrl = 'https://www.googleapis.com/robot/v1/metadata/x509/securetoken@system.gserviceaccount.com';
            let publicKeyResponse = yield fetch(publicKeyUrl);
            let publicKey = yield publicKeyResponse.json();
            let decodedToken = yield JWT.validate(tokenStr, {
                algorithm: 'RS256',
                secretOrKey: publicKey
            });
            if (decodedToken.claims.u) {
                return decodedToken.claims.u;
            }
            let uid = decodedToken.claims.uid;
            //let user = await firebaseAdmin.auth().getUser(uid);
            return {
                id: uid,
                uid,
                createdAt: null,
                updatedAt: null,
                email: decodedToken.claims.email,
                displayName: null,
                avatarUrl: null,
                username: 'bob' // TODO
            };
        });
    }
    getUsersByUsernames(names) {
        return __awaiter(this, void 0, void 0, function* () {
            if (names.length > 20)
                throw new Error(`Lookup via this method is limited to 20`);
            return yield Promise.all(names.map(name => this.getUserByUsername(name)));
        });
    }
    getUsersByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            if (ids.length > 20)
                throw new Error(`Lookup via this method is limited to 20`);
            return yield Promise.all(ids.map(id => this.getUserById(id)));
        });
    }
    getUserByUsername(username) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.datastore.read(`/usernames/${username}`);
        });
    }
    getUserById(uid) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.datastore.read(`/users/${uid}`);
        });
    }
};
FirebaseAuthenticationProvider = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [FirebaseStoreRef])
], FirebaseAuthenticationProvider);
export { FirebaseAuthenticationProvider };
//# sourceMappingURL=firebase-authentication-provider.js.map